import { PaginationRequest } from 'features/pagination/types/paginationRequest';
import { CacheItem, DefaultTags } from './genericCacheUtils';

export type CacheListWithPagination<T, ID> = (
  | CacheItem<T, 'PAGED-LIST'>
  | CacheItem<T, ID>
  | DefaultTags
)[];

export const cacheByPaginationQueryArgs =
  <T extends string>(type: T) =>
  <Arg extends PaginationRequest<any>, Result = undefined, Error = undefined>(
    result: Result,
    error: Error,
    arg: Arg
  ): CacheItem<T, string>[] =>
    [
      {
        type,
        id: `${arg.page}-${arg.pageSize}-${arg.startDate}-${arg.endDate}-${arg.searchTerm}-${arg.seekValue}-${arg.seekId}`
      }
    ];
